var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-window__header d-flex align-center px-4 py-3" },
    [
      _c(
        "v-avatar",
        {
          staticClass: "mr-3",
          class: { "avatar-clickable": _vm.contactFotoUrl },
          attrs: {
            size: "36",
            color: _vm.isGroup ? "blue-grey lighten-3" : "grey lighten-2"
          },
          on: { click: _vm.onOpenProfile }
        },
        [
          _vm.contactFotoUrl
            ? _c("img", {
                attrs: { src: _vm.contactFotoUrl, alt: _vm.contactName }
              })
            : _vm.isGroup
            ? _c("icon-svg", {
                attrs: {
                  name: _vm.icons.accountGroup,
                  size: "20",
                  color: "white"
                }
              })
            : _c(
                "span",
                { staticClass: "az-text-primary az-size-14 font-medium" },
                [_vm._v(_vm._s(_vm.contactName.charAt(0)))]
              )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex-grow-1" },
        [
          _c("div", { staticClass: "az-text-primary az-size-14 font-medium" }, [
            _vm._v(_vm._s(_vm.contactName))
          ]),
          _vm.isGroup
            ? _c("div", { staticClass: "az-text-small" }, [
                _vm._v(" Grupo WhatsApp"),
                _vm.participantCount > 0
                  ? _c("span", [
                      _vm._v(
                        " · " + _vm._s(_vm.participantCount) + " participantes"
                      )
                    ])
                  : _vm._e()
              ])
            : _c("div", { staticClass: "az-text-small" }, [
                _vm._v(_vm._s(_vm.contactPhone))
              ]),
          _vm.showConexaoChip
            ? _c(
                "v-chip",
                {
                  staticClass: "mt-1",
                  attrs: {
                    "x-small": "",
                    color: _vm.$setOpacity(_vm.conexaoChipColor, 0.15),
                    "text-color": _vm.conexaoChipColor,
                    "data-test": "conexao-chip"
                  }
                },
                [
                  _c("icon-svg", {
                    staticClass: "mr-1",
                    attrs: {
                      name: _vm.icons.connections,
                      size: "12",
                      color: _vm.conexaoChipColor
                    }
                  }),
                  _vm._v(" " + _vm._s(_vm.conexaoNome) + " ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("ChatActionsMenu", {
        attrs: {
          conversa: _vm.selectedConversa,
          "data-test": "chat-actions-menu"
        },
        on: {
          atribuir: _vm.onAtribuir,
          transferir: _vm.onTransferir,
          escalar: _vm.onEscalar,
          fechar: _vm.onFechar
        }
      }),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "",
                          small: "",
                          "data-test": "import-history-btn"
                        },
                        on: { click: _vm.onImportHistory }
                      },
                      on
                    ),
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: _vm.icons.history,
                          size: "16",
                          color: "#8E8E8E"
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [_c("span", [_vm._v("Importar histórico do WhatsApp")])]
      ),
      _vm.showCloseConversa
        ? _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticClass: "ml-1",
                              attrs: {
                                icon: "",
                                small: "",
                                "data-test": "close-conversa-btn"
                              },
                              on: { click: _vm.onCloseConversa }
                            },
                            on
                          ),
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.icons.close,
                                size: "12",
                                color: "#8E8E8E"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                2217750535
              )
            },
            [_c("span", [_vm._v("Fechar conversa")])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }